import { fmtTime } from '../lib/format';
import type { WsEvent } from '../api/wsClient';

export function EventsFeed({ events }: { events: Array<{ at: string; e: WsEvent }> }) {
  return (
    <div className="panel">
      <h3>Live events</h3>
      <div className="events">
        {events.length === 0 ? (
          <div className="hint">Waiting for fills, position updates, and order status changes…</div>
        ) : (
          events.slice(-50).reverse().map((row, i) => (
            <div className="ev" key={i}>
              <span className="t">{fmtTime(row.at)}</span>
              <span className="k">{row.e.type}</span>
              <span className="mono">{summarisePayload(row.e)}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function summarisePayload(e: WsEvent): string {
  const p = (e.payload ?? {}) as Record<string, any>;
  switch (e.type) {
    case 'FillEmitted':
      return `${p.side ?? ''} ${p.quantity ?? ''} ${p.symbol ?? ''} @ ${p.averagePrice ?? p.price ?? ''}`;
    case 'PositionUpdated':
      return `${p.position?.symbol ?? ''} qty=${p.position?.quantity ?? ''} (${p.reason ?? ''})`;
    case 'OrderStatusChanged':
      return `${p.order?.symbol ?? p.payload?.symbol ?? ''} status=${p.order?.status ?? p.result?.status ?? ''}`;
    case 'L2Tick':
      return `${p.symbol ?? ''} bid=${p.bid ?? ''} ask=${p.ask ?? ''}`;
    default:
      return JSON.stringify(p);
  }
}
